import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ReactComponent as CaleidoLogo } from 'assets/images/common/logo.svg';
import { Bell, Menu } from 'lucide-react';

const HomeAIHeader: React.FC = () => {
  const navigate = useNavigate();
  const notificationCount = 0; // This would normally come from an API or state

  return (
    <div className="flex items-center justify-between w-full px-5 py-12">
      <div className="flex items-center">
        <Link to="/" className="flex items-center">
          <CaleidoLogo className="h-[0.875rem] w-full" />
        </Link>
      </div>

      <div className="flex items-center gap-4">
        <div className="relative">
          <Bell
            className="w-7 h-7 cursor-pointer"
            onClick={() => navigate('/activities')}
          />
          {notificationCount > 0 && (
            <div className="absolute -top-2 -right-2 bg-[#FF7F7F] text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
              {notificationCount > 99 ? '99+' : notificationCount}
            </div>
          )}
        </div>
        <Menu className="w-6 h-6 cursor-pointer" />
      </div>
    </div>
  );
};

export default HomeAIHeader;
